import React, { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Instagram, Facebook, Search, Heart, User, ShoppingBag, Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { NAV, CONTACT } from "./siteData";
import { BrandLogo, TryFabButton } from "./PremiumHero";
import { StudioFooter } from "./StudioCTA";

function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header className="sticky top-0 z-50" data-testid="site-nav">
      {false && (
      <div className="bg-[#8B6B3A] py-2 text-center text-[11px] uppercase tracking-[0.25em] text-white">
        Complimentary shipping on orders over ₹2,500
      </div>
      )}
      <div className={`border-b border-[#E8E0D2] bg-[#FBF8F2] transition-shadow duration-500 ${scrolled ? "shadow-sm" : ""}`}>
        <div className="mx-auto flex h-20 max-w-[1400px] items-center justify-between px-6 lg:px-12">
          <Link to="/" className="font-display text-3xl tracking-[0.22em] text-[#2A2220]" data-testid="nav-logo">
          <BrandLogo />
        </Link>
          <nav className="hidden items-center gap-8 lg:flex">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) => `relative text-[13px] uppercase tracking-[0.15em] transition-colors hover:text-[#8B6B3A] after:absolute after:-bottom-1.5 after:left-0 after:h-px after:bg-[#8B6B3A] after:transition-all after:duration-500 ${isActive ? "text-[#8B6B3A] after:w-full" : "text-[#3a3330] after:w-0 hover:after:w-full"}`}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-5 text-[#2A2220]">
            <TryFabButton />
            <button aria-label="Search" className="hidden hover:text-[#8B6B3A] lg:block"><Search className="h-[18px] w-[18px]" strokeWidth={1.5} /></button>
            <button aria-label="Wishlist" className="hidden hover:text-[#8B6B3A] lg:block"><Heart className="h-[18px] w-[18px]" strokeWidth={1.5} /></button>
            <Link to="/login" aria-label="Account" className="hidden hover:text-[#8B6B3A] lg:block"><User className="h-[18px] w-[18px]" strokeWidth={1.5} /></Link>
            <Link to="/contact" aria-label="Request quote" className="hidden hover:text-[#8B6B3A] lg:block" data-testid="nav-request-quote"><ShoppingBag className="h-[18px] w-[18px]" strokeWidth={1.5} /></Link>
            <button className="lg:hidden" onClick={() => setOpen(true)} data-testid="nav-menu-open" aria-label="Open menu"><Menu className="h-6 w-6" /></button>
          </div>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-[#FBF8F2] px-6 py-6 lg:hidden" data-testid="mobile-menu">
            <div className="flex items-center justify-between">
              <span className="font-display text-xl tracking-[0.18em]">NAYARA<span className="text-[#8B6B3A]"> STUDIO</span></span>
              <button onClick={() => setOpen(false)} data-testid="nav-menu-close"><X className="h-6 w-6" /></button>
            </div>
            <nav className="mt-14 flex flex-col gap-7">
              {NAV.map((n, i) => (
                <motion.div key={n.to} initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }}>
                  <NavLink to={n.to} onClick={() => setOpen(false)} className="font-display text-3xl font-light text-[#1A1A1A]">{n.label}</NavLink>
                </motion.div>
              ))}
              <Link to="/contact" onClick={() => setOpen(false)} className="mt-4 w-fit rounded-full bg-[#1A1A1A] px-7 py-3 text-sm text-[#FAF9F6]">Request Quote</Link>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}

export default function SiteLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" }); }, [pathname]);
  return (
    <div className="site-body min-h-screen bg-[#FBF8F2] text-[#1A1A1A]">
      <Nav />
      <motion.main key={pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Outlet />
      </motion.main>
      <StudioFooter />
    </div>
  );
}